

























import Vue from 'vue';
import { default as ColourPicker } from '@/shared/services/color';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { HomescreenAppInitViewModel } from '../../models/response/homescreenAppInitViewModel';
import HomeScreenHeader from './HomeScreenHeader.vue';
import HomeScreenPanelStartChat from './HomeScreenPanelStartChat.vue';
import CardRenderer from '@/shared/components/cardRenderer/CardRenderer.vue';
import { Card } from '@/shared/components/cardRenderer';

@Component({
	components: { HomeScreenHeader, HomeScreenPanelStartChat, CardRenderer }
})
export default class HomeScreenPreview extends Vue {
	@Prop() public brandColour: string;
	@Prop() public actionColour: string;
	@Prop() public homescreenImageUrl: string;
	@Prop() public greetingText: string;
	@Prop() public introductionText: string;
	@Prop() public typicalResponseTime: string;

	@Prop() public homescreenApps: HomescreenAppInitViewModel[];

	public cards: Card[] = [];

	public $refs: {
		panelContainer: HTMLElement,
	};

	@Watch('homescreenApps')
	public onHomescreenAppsChanged(value: HomescreenAppInitViewModel[]) {
		this.cards = value.map(app => ({ id: app.id, content: app.card }));
	}

	public getDarkPrimary() {
		return ColourPicker.darken(this.brandColour, 12);
	}

	get textColour() {
		return ColourPicker.getContrastingColour(this.brandColour);
	}
}
